/**
 * Save content as a file using the browser's native API (no dependencies).
 * @param content - The content to save (string)
 * @param filename - The name of the file to save as
 * @param type - The type of the file to save as (json or css)
 */
export function saveAs(
  content: string,
  filename: string,
  type: 'json' | 'css'
) {
  const typeMap = {
    json: 'application/json',
    css: 'text/css'
  }

  const blob = new Blob([content], {type: typeMap[type]})
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  setTimeout(() => {
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }, 0)
}
